import { useState, useRef, useCallback } from 'react';

import { PAGE_COUNT } from "UTILS/Constants";

export const useLimit = () => {
  const [limit, setLimit] = useState(PAGE_COUNT[0]);
  const limitRef = useRef(PAGE_COUNT[0]);
  const updateLimit = useCallback((nextLimit) => {
    setLimit(nextLimit);
    limitRef.current = nextLimit;
  }, []);
  
  return {
    limit,
    limitRef,
    updateLimit,
  }
}